import React from "react";
import classnames from "classnames";
import { useFormContext, Controller } from "react-hook-form";
import {
  Button,
  FormFeedback,
  FormGroup,
  Label,
  Input,
} from "reactstrap";

const TableNameField = (props) => {
  const {
    index,
    isNumeric,
    onDelete,
    numOfFields,
  } = props;

  const { register, errors, watch, control } = useFormContext();
  const tableNames = watch("tableNames") || [];
  const tableName = tableNames[index] || {};
  const buildingName = watch("tableBuildingParameter.building_name") || "";

  return (
    <div className="mb-4 border rounded p-3">
      <div> 
        {`Table Name: log_${buildingName}_${tableName.asset_name}`}
      </div>
      <div> 
        {`Thing Name: ${buildingName}_${tableName.asset_name}`}
      </div>
      <FormGroup className="mt-3" style={{ display: 'flex', gap: '1rem' }}>
        <div>
          <Label for="name">
            Asset Name <span className="text-danger">*</span>
          </Label>
          <Input
            id={`asset_name_${index}`}
            name={`tableNames[${index}].asset_name`}
            defaultValue={tableName.asset_name || ""}
            placeholder="e.g. ass1/bat1"
            innerRef={register({
              required: true,
              validate: (value) => {
                const duplicateCount = tableNames.filter((item, i) => {
                  return i !== index && item.asset_name === value;
                }).length;

                return duplicateCount === 0 || "Asset names must be unique";
              }
            })}
            className={classnames({
              "is-invalid": errors.tableNames?.[index]?.asset_name,
            })}
          />
          {errors.tableNames?.[index]?.asset_name && (
            <FormFeedback>{errors.tableNames?.[index]?.asset_name.message}</FormFeedback>
          )}
        </div>
        <div>
          <Label for="contractedCap">Uncontracted Capacity</Label>
          <Input
            id={`contractedCap_${index}`}
            name={`tableNames[${index}].contractedCap`}
            defaultValue={tableName.contractedCap || ""}
            innerRef={register({
              validate: (value) => isNumeric(value),
            })}
            className={classnames({
              "is-invalid": errors.tableNames?.[index]?.contractedCap,
            })}
          />
          {errors.tableNames?.[index]?.contractedCap && (
            <FormFeedback>Must be a valid number</FormFeedback>
          )}
        </div>
      </FormGroup>
      <FormGroup style={{ display: 'flex', gap: '1rem' }}>
        <div>
          <Label for="limitedRate">Limited Charge Rate</Label>
          <Input
            id={`limitedRate_${index}`}
            name={`tableNames[${index}].limitedRate`}
            defaultValue={tableName.limitedRate || ""}
            innerRef={register({
              validate: (value) => isNumeric(value),
            })}
            className={classnames({
              "is-invalid": errors.tableNames?.[index]?.limitedRate,
            })}
          />
          {errors.tableNames?.[index]?.limitedRate && (
            <FormFeedback>Must be a valid number</FormFeedback>
          )}
        </div>
        <div>
          <Label for="batMSB">Battery MSB</Label>
          <Input
            id={`batMSB_${index}`}
            name={`tableNames[${index}].batMSB`}
            defaultValue={tableName.batMSB || ""}
            placeholder="e.g. MSB1"
            innerRef={register()}
          />
        </div>
      </FormGroup>
      <FormGroup style={{ display: 'flex', gap: '1rem' }}>
        <div>
          <Label for="batCap">Battery Capacity</Label>
          <Input
            id={`batCap_${index}`}
            name={`tableNames[${index}].batCap`}
            defaultValue={tableName.batCap || ""}
            innerRef={register({
              validate: (value) => isNumeric(value),
            })}
            className={classnames({
              "is-invalid": errors.tableNames?.[index]?.batCap,
            })}
          />
          {errors.tableNames?.[index]?.batCap && (
            <FormFeedback>Must be a valid number</FormFeedback>
          )}
        </div>
        <div>
          <Label for="chargeRate">Charge Rate</Label>
          <Input
            id={`chargeRate_${index}`}
            name={`tableNames[${index}].chargeRate`}
            defaultValue={tableName.chargeRate || ""}
            innerRef={register({
              validate: (value) => isNumeric(value),
            })}
            className={classnames({
              "is-invalid": errors.tableNames?.[index]?.chargeRate,
            })}
          />
          {errors.tableNames?.[index]?.chargeRate && (
            <FormFeedback>Must be a valid number</FormFeedback>
          )}
        </div>
      </FormGroup>
      <FormGroup>
      <Controller
        name={`tableNames[${index}].can_script_change_state`}
        control={control}
        defaultValue={tableName.can_script_change_state || 0}
        render={({ value, onChange }) => (
          <Input
            type="checkbox"
            id={`can_script_change_state${index}`}
            label="Can script change state?"
            checked={!!value}
            onChange={(e) => onChange(e.target.checked ? 1 : 0)}
          />
        )}
      />
    </FormGroup>
    <FormGroup>
      <Input
        type="hidden"
        id={`db_id_${index}`}
        name={`tableNames[${index}].db_id`}
        defaultValue={tableName.db_id || ""}
        innerRef={register()}
      />
    </FormGroup>

    {numOfFields > 1 && (
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "1rem" }}>
        <Button 
          className="mr-3 btn-rounded" 
          type="button" 
          color="danger"
          onClick={onDelete}
        >
          Delete
        </Button>
      </div>
    )}
    </div>
  );
};

export default TableNameField;
